import { UI, Stack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';
import { useSetRecoilState } from 'recoil';

import {
  SignedInNavigationScreenNavigationProp,
  CustomerDetailStackParamList,
} from '../../../../../../routes/types';
import { updatePrivatePensionSelectedWithCustomerInfo } from '../../../../../../store/customerDetail/privatePension/selectors';
import { CustomerPrivatePensionContractedNormalized } from '../../../../../../store/customerDetail/privatePension/types';
import { PrivatePensionContractedTabProps } from '../../constants';

import { getPrivatePensionActionsList, PrivatePensionOptions } from './constants';

export interface ActionButtonsProps extends PrivatePensionContractedTabProps {
  privatePension: CustomerPrivatePensionContractedNormalized;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({ privatePension, setSelectedTab }) => {
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const updateInfo = useSetRecoilState(updatePrivatePensionSelectedWithCustomerInfo);

  const handleChangeOption = (newValue: PrivatePensionOptions | string) => {
    updateInfo({ privatePension, ...params });
    switch (newValue as PrivatePensionOptions) {
      case 'privatePensionApplication':
        navigate('PrivatePensionNewApplicationModal', { ...params, privatePension });

        break;
      case 'secondCopy':
        setSelectedTab('secondCopy');
        break;
      case 'changeBeneficiaries':
        setSelectedTab('changeBeneficiaries');
        break;
      case 'downloadProposal':
        console.log('DOWNLOAD DA PROPOSTA');
        break;
    }
  };

  return (
    <Stack
      backgroundColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 0.45)}
      borderRadius={BoxBorder.heavy}
      p={Spacing['inset.quarck']}>
      <UI.Select
        placeholder=""
        options={getPrivatePensionActionsList(privatePension.insurer)}
        onValueChange={handleChangeOption}
        triggerIconProps={{
          name: 'MenuExtension',
          size: 'xs',
          color: Color['brand.primary.principal'],
        }}
        showOnlyIcon
        triggerProps={{ padding: 0 }}
        optionsDesktopDirection="left"
      />
    </Stack>
  );
};
